import React from 'react';

/*
This function creates a react fragment with the text and the icons, in given order.
The order of icons is determined by their occurrence in the text.

@param {string} text - The text to be split and mapped.
@param {Object} icons - An object where keys are icon names and values are icon components
@returns {React.ReactNode[]} - The list of react fragments with the text and the icons in the correct order.
*/
export const getStringWithIcon = ({ text, icons }) => {
  const iconNames = Object.keys(icons);
  const splitDescription = recursiveSplitter(text, iconNames);
  if (typeof splitDescription === 'string') {
    return [<>{splitDescription}</>];
  }
  const result = splitDescription.map((item, index) => (
    <>
      {item}
      {index < iconNames.length ? icons[iconNames[index]] : null}
    </>
  ));
  return result;
};

export const calculateHeightWeeklyPlan = () => {
  const getHeightElement = (id) =>
    document.getElementById(id)?.offsetHeight || 0;
  const mainHeader = getHeightElement('toolbar_container');
  const toolbarSubmodule = getHeightElement('menu_submodules');
  const toolbarWeeklyPLan = getHeightElement('weeklyplan_toolbar');
  const height = mainHeader + toolbarSubmodule + toolbarWeeklyPLan;
  return height;
};

export const getHeightWeeklyPlan = () =>
  `calc(100vh - ${calculateHeightWeeklyPlan()}px)`;

const recursiveSplitter = (text, delimiterList) => {
  if (delimiterList.length === 0) {
    return text;
  }

  const delimiter = delimiterList[0];
  const splitText = text.split(delimiter);

  if (splitText.length === 1) {
    return recursiveSplitter(text, delimiterList.slice(1));
  }

  return [
    splitText[0],
    ...recursiveSplitter(splitText[1], delimiterList.slice(1))
  ];
};
